var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revision-manager"
  }, [_c('nav', {
    staticClass: "uk-navbar-container revision-manager__nav",
    attrs: {
      "uk-navbar": ""
    }
  }, [_c('div', {
    staticClass: "uk-navbar-left"
  }, [_c('div', {
    staticClass: "uk-navbar-item uk-logo"
  }, [_vm._v("\n        Revisionen für: \n        "), _vm._t("title", [_vm._v(_vm._s(_vm.parent.name))])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "uk-navbar-right"
  }, [_c('div', {
    staticClass: "uk-navbar-item"
  }, [_c('cancel-button', {
    staticClass: "uk-margin-right",
    attrs: {
      "text": _vm.$t('actions.back')
    }
  })], 1)])]), _vm._v(" "), (_vm.hasRevisions) ? _c('table', {
    staticClass: "revision-manager__grid uk-table uk-table-divider"
  }, [_c('thead', {
    staticClass: "revision-manager__grid-header"
  }, [_c('tr', [_c('th', {
    staticClass: "revision-manager__header uk-table-shrink uk-text-right"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('historicalData')) + "\n        ")]), _vm._v(" "), _vm._l((_vm.revisions), function(revision) {
    return _c('th', {
      staticClass: "revision-manager__cell revision-manager__header",
      class: {
        'revision-manager__header--active': revision.active
      }
    }, [_c('revision-validity', {
      attrs: {
        "from": revision.validFrom,
        "until": revision.validUntil
      }
    }), _vm._v(" "), (revision.active) ? _c('live-indicator', {
      staticClass: "uk-align-right uk-margin-remove"
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('th', {
    staticClass: "revision-manager__header uk-table-shrink"
  }, [(_vm.newRevisionRoute) ? _c('router-link', {
    attrs: {
      "to": _vm.newRevisionRoute,
      "title": _vm.$t('actions.addRevision')
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  })], 1) : _c('a', {
    attrs: {
      "href": "#",
      "title": _vm.$t('actions.addRevision')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addRevision($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1)], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.fields), function(field) {
    return _c('tr', [_c('td', {
      staticClass: "revision-manager__cell uk-table-shrink uk-text-right uk-text-bold"
    }, [_vm._v("\n          " + _vm._s(_vm.$t(("fields." + field))) + "\n        ")]), _vm._v(" "), _vm._l((_vm.revisions), function(revision) {
      return _c('td', {
        staticClass: "revision-manager__cell",
        class: {
          'revision-manager__cell--active': revision.active
        }
      }, [_vm._t(field, [(revision[field]) ? _c('span', [_vm._v(_vm._s(revision[field]))]) : _c('text-placeholder')], {
        value: revision[field]
      })], 2)
    }), _vm._v(" "), _c('td', {
      staticClass: "revision-manager__cell uk-table-shrink"
    })], 2)
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "revision-manager__footer uk-table-shrink"
  }), _vm._v(" "), _vm._l((_vm.revisions), function(revision) {
    return _c('td', {
      staticClass: "revision-manager__footer",
      class: {
        'revision-manager__footer--active': revision.active
      }
    }, [_c('common-button', {
      attrs: {
        "icon": "pencil"
      },
      on: {
        "click": function($event) {
          _vm.editRevision(revision)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('actions.edit')) + "\n          ")]), _vm._v(" "), _c('common-button', {
      attrs: {
        "type": "danger",
        "icon": "trash"
      },
      on: {
        "click": function($event) {
          _vm.deleteRevision(revision)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$t('actions.delete')) + "\n          ")])], 1)
  }), _vm._v(" "), _c('td', {
    staticClass: "revision-manager__footer uk-table-shrink"
  })], 2)])]) : _c('div', {
    staticClass: "uk-text-center uk-margin-large uk-margin-large-top uk-margin-large-left uk-margin-large-right"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('hints.noRevisions')) + "\n\n    "), _c('div', {
    staticClass: "uk-margin-top"
  }, [(_vm.newRevisionRoute) ? _c('link-button', {
    attrs: {
      "to": _vm.newRevisionRoute,
      "size": "large",
      "icon": "plus"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.addRevision')) + "\n      ")]) : _c('common-button', {
    attrs: {
      "size": "large",
      "icon": "plus"
    },
    on: {
      "click": _vm.addRevision
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.addRevision')) + "\n      ")])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3104e227","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/RevisionManager.vue
// module id = 1922
// module chunks = 0